import $ = require("jquery");
import _ = require("underscore");
import arcgis = require("arcgis/services/featureserver/layer");

let sqrt2 = Math.sqrt(2);

function as(v) {
    return "" + v + "px";
};

// convert directly to html (not used)
class Converter {

    static about = `Converts a symbol definition to HTML`;

    // rename toCss
    private asRgba(color: string | Array<number>) {
        if (typeof color === "string") return color;
        else {
            let c = { r: color[0], g: color[1], b: color[2], a: color[3] };
            if (typeof c.a === "undefined") c.a = 1;
            if (c.a > 1) c.a /= 255; // normalize
            return `rgba(${c.r},${c.g},${c.b},${c.a})`;
        }
    }

    private asImageData(symbol: {
        contentType?: string;
        imageData?: string;
    }) {
        var url = `data:${symbol.contentType};base64,${symbol.imageData}`;
        return `url(${url})`;
    }

    private asOutline($div: JQuery, outline: arcgis.Outline) {
        _.defaults(outline, {
            color: "black",
            width: "1",
            style: "solid"
        });

        $div.css({
            borderColor: this.asRgba(outline.color),
            borderWidth: as(outline.width),
            borderStyle: outline.style
        });
    }

    asTemplate(symbol: arcgis.Symbol);
    asTemplate(div: HTMLElement, symbol: arcgis.Symbol);
    asTemplate(div?: HTMLElement|arcgis.Symbol, symbol?: arcgis.Symbol) {
        if (!symbol) {
            symbol = <any>div;
            div = document.createElement("div");
        }
        symbol = _.defaults(symbol, {
            type: "default",
            style: "default"
        });

        console.log("convertion symbol to template: ", symbol);

        let $div = $(div);

        $div.addClass(symbol.type);
        $div.addClass(symbol.style);

        switch (symbol.type) {

            case "esriSMS":
                $div.css({
                    width: as(symbol.size),
                    height: as(symbol.size),
                    backgroundColor: this.asRgba(symbol.color)
                });
                symbol.outline && this.asOutline($div, symbol.outline);

                switch (symbol.style) {
                    case "esriSMSCircle":
                        $div.css({
                            width: as(2 * symbol.size),
                            height: as(2 * symbol.size),
                            borderRadius: as(symbol.size)
                        });
                        break;

                    case "esriSMSCross":
                    case "esriSMSX":
                        // trial and ERROR -- here we go!
                        $div.css({
                            backgroundColor: this.asRgba(symbol.color),
                            width: as(0.2 * symbol.size),
                            height: as(symbol.size),
                            border: "none",
                            marginLeft: as(0.4 * symbol.size)
                        });
                        {
                            let $helper = $("<div>");
                            $helper.css({
                                backgroundColor: this.asRgba(symbol.color),
                                position: "absolute",
                                top: as(0.4 * symbol.size),
                                left: as(-0.4 * symbol.size),
                                width: as(symbol.size),
                                height: as(0.2 * symbol.size)
                            });

                            $div.append($helper);
                        }
                        break;

                    case "esriSMSDiamond":
                        $div.css({
                            width: as(symbol.size / sqrt2),
                            height: as(symbol.size / sqrt2)
                        });
                        if (symbol.outline) {
                            let width = sqrt2 * symbol.outline.width;
                            let sx = width * 2;
                            $div.css({
                                width: as(symbol.size - sx),
                                height: as(symbol.size - sx),
                                borderWidth: as(width),
                                marginTop: as(symbol.yoffset || 0),
                                marginLeft: as(symbol.xoffset || 0),
                            });
                        }
                        break;
                }
                break;

            case "esriPMS":
            case "esriPFS":
                // background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIA...);
                $div.css({
                    width: symbol.width + "pt",
                    height: symbol.height + "pt",
                    backgroundImage: this.asImageData(symbol),
                    backgroundPositionX: symbol.xoffset || 0,
                    backgroundPositionY: symbol.yoffset || 0,
                    backgroundRepeat: "no-repeat"
                });
                break;

            case "esriSLS":
                $div.addClass(symbol.style);
                var style = $div.css({
                    width: Math.max(0, 64 - symbol.width) + "pt",
                    height: Math.max(12, 2 * symbol.width) + "pt",
                    borderColor: this.asRgba(symbol.color),
                    borderTopRightRadius: (1.5 * symbol.width) + "pt",
                    borderWidth: symbol.width + "pt"
                });
                break;

            case "esriSFS":
                switch (symbol.style) {
                    case "esriSFSSolid":
                    case "esriSFSForwardDiagonal":
                        // need to create a fill...probably use dojox.gfx here
                        var style = $div.css({
                            backgroundColor: this.asRgba(symbol.color),
                            width: Math.max(0, 32 - 2 * symbol.outline.width) + "pt",
                            height: Math.max(0, 32 - 2 * symbol.outline.width) + "pt",
                            borderStyle: "solid",
                            borderColor: this.asRgba(symbol.outline.color),
                            borderRadius: (1.5 * symbol.outline.width) + "pt",
                            borderWidth: symbol.outline.width + "pt"
                        });
                        break;
                }
                break;

            default:
                console.log(`unsupported symbol type: ${symbol.type}`);
        }

        $div.attr("title", JSON.stringify(symbol));
        return div;
    }

}

export = Converter;
